/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import noUser from '../assets/img/no_user.jpg';
import { updateUser, updateUserImage } from '../services/user';
import MyDropZone from '../comman/component/uploadfile.component';
import { setUserData } from '../redux/auth/auth.action';
import { setActiveTab } from '../redux/active-tabs/active-tab.action';
import { ReactComponent as EyeIcon } from '../assets/svg/eye-off-outline.svg';
import { ReactComponent as EyeOffIcon } from '../assets/svg/eye-outline.svg';
import ReactInputMask from 'react-input-mask';
import { PHONE_REG_EXP } from '../helper/constant';
import { normalizePhone } from '../helper/phone';
import FooterEnd from 'comman/component/footerEnd';
import { toast } from 'react-toastify';

const ProfilePage = ({ user, setUserData, setActiveTab, showToast }) => {
  const history = useHistory();
  const [showHidePassword, setShowHidePassword] = useState(false);
  const [showHideConfirmPassword, setShowHideConfirmPassword] = useState(false);
  const [editInitialValues, setEditInitialValues] = useState({
    id: '',
    username: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: '',
  });
  const initialPreviewScreen = {
    firstName: '',
    lastName: '',
    username: '',
    phone: '',
    image: noUser,
  };
  const [previewScreen, setPreviewScreen] = useState(initialPreviewScreen);
  const [blobURL, setBlobURL] = useState({
    previous: '',
    current: '',
    next: '',
  });
  const [profileImage, setProfileImage] = useState([]);
  const [profile, setProfile] = useState([]);
  useEffect(() => {
    setEditInitialValues((prevState) => ({
      ...prevState,
      id: user._id,
      username: user.username,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
    }));

    setPreviewScreen((prevState) => ({
      ...initialPreviewScreen,
      username: user.username,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
    }));
  }, [user]);

  const editValidationSchema = Yup.object().shape(
    {
      username: Yup.string().required('Username is required'),
      firstName: Yup.string().required('FirstName is required'),
      lastName: Yup.string().required('LastName is required'),
      confirmPassword: Yup.string().when('password', (password) => {
        if (password)
          return Yup.string()
            .required('Confirm password required')
            .oneOf([Yup.ref('password'), null], 'Passwords must match');
      }),
      password: Yup.string().when('confirmPassword', (confirmPassword) => {
        if (confirmPassword) return Yup.string().required('Password required');
      }),

      phone: Yup.string()
        .transform((value, originalValue) => {
          return normalizePhone(originalValue);
        })
        .matches(PHONE_REG_EXP, 'Phone number is not valid'),
    },
    [['confirmPassword', 'password']]
  );

  const uploadUserImage = async (fileData) => {
    // setShowImageEditor(true);
    setProfileImage(fileData);
    setBlobURL({
      previous: fileData[0].preview,
      current: fileData[0].preview,
      next: fileData[0].preview,
    });
  };

  const submitFunction = async (value) => {
    try {
      const userId = value.id;
      delete value.id;
      delete value.confirmPassword;
      if (value.password === '') {
        delete value.password;
      }
      const response = await updateUser(userId, value);
      if (response.status === 200) {
        setUserData({
          ...user,
          firstName: value.firstName,
          lastName: value.lastName,
          username: value.username,
          phone: value.phone,
        });
        if (profileImage.length) {
          const fileName = profileImage[0].name;
          const formData = new FormData();
          formData.append(
            'fieldModifiers',
            JSON.stringify({ avatar: fileName })
          );
          let demo = await fetch(blobURL.next).then((r) => r.blob());
          formData.append('file', demo, fileName);
          const res = await updateUserImage(userId, formData);

          if (res.status === 413) {
            toast('Avatar is larger than 1MB');
            return;
          }

          if (res.status === 200) {
            setProfileImage([]);

            setUserData({
              ...user,
              avatar: profileImage[0].name,
            });
          }
        }
      }
      setActiveTab('home');
      history.push('/index');
    } catch (error) {}
  };

  return (
    <div id='pageWrapper'>
      <div className='main-page'>
        <div className='page-wrapper'>
          <section className='common-sec setting-sec'>
            <div className='container-fluid'>
              <div className='row row align-items-center justify-content-center'>
                <div className='col-12 col-md-8 col-lg-8 left-clm'>
                  <div className='card'>
                    <div className='card-header'>
                      <h2>User Profile</h2>
                    </div>
                    <div className='card-body '>
                      <div className='setting-form-wrapper row'>
                        <div className='col-12 col-md-12 col-lg-12'>
                          <Formik
                            enableReinitialize={true}
                            initialValues={editInitialValues}
                            validationSchema={editValidationSchema}
                            onSubmit={async (value, { resetForm }) => {
                              await submitFunction(value);
                              resetForm({ values: '' });
                            }}>
                            {({
                              values,
                              errors,
                              isValid,
                              setFieldValue,
                              isSubmitting,
                            }) => (
                              <Form>
                                <div>
                                  <div className='main-profile-photo'>
                                    <MyDropZone
                                      uploadUserImage={uploadUserImage}
                                      setPreviewScreen={setPreviewScreen}
                                      itemId={editInitialValues.id}
                                      profile={profile}
                                      setProfile={setProfile}
                                      member='user'
                                      previewScreen={previewScreen}
                                    />
                                  </div>
                                  <Field type='hidden' name='id' />
                                  <div className='user-modal-filed-wrapper'>
                                    <div className='row'>
                                      <div className='col-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                          <Field
                                            className='form-control'
                                            type='text'
                                            name='firstName'
                                            placeholder='First Name'
                                            onChange={(e) => {
                                              setPreviewScreen((prevState) => ({
                                                ...prevState,
                                                firstName: e.target.value,
                                              }));
                                              setFieldValue(
                                                'firstName',
                                                e.target.value
                                              );
                                            }}
                                          />
                                          <ErrorMessage name='firstName'>
                                            {(msg) => (
                                              <span
                                                className='fm_error'
                                                style={{ color: 'red' }}>
                                                {msg}
                                              </span>
                                            )}
                                          </ErrorMessage>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                          <Field
                                            className='form-control'
                                            type='text'
                                            name='lastName'
                                            placeholder='Last Name'
                                            onChange={(e) => {
                                              setPreviewScreen((prevState) => ({
                                                ...prevState,
                                                lastName: e.target.value,
                                              }));
                                              setFieldValue(
                                                'lastName',
                                                e.target.value
                                              );
                                            }}
                                          />
                                          <ErrorMessage name='lastName'>
                                            {(msg) => (
                                              <span
                                                className='fm_error'
                                                style={{ color: 'red' }}>
                                                {msg}
                                              </span>
                                            )}
                                          </ErrorMessage>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                          <Field
                                            className='form-control'
                                            type='text'
                                            name='phone'
                                            placeholder='Enter Number'
                                            onChange={(e) => {
                                              setPreviewScreen((prevState) => ({
                                                ...prevState,
                                                phone: e.target.value,
                                              }));
                                              setFieldValue(
                                                'phone',
                                                e.target.value
                                              );
                                            }}
                                          />
                                          <ErrorMessage name='phone'>
                                            {(msg) => (
                                              <span
                                                className='fm_error'
                                                style={{ color: 'red' }}>
                                                {msg}
                                              </span>
                                            )}
                                          </ErrorMessage>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                          <Field
                                            className='form-control'
                                            type='text'
                                            name='username'
                                            placeholder='User Name'
                                            onChange={(e) => {
                                              setPreviewScreen((prevState) => ({
                                                ...prevState,
                                                username: e.target.value,
                                              }));
                                              setFieldValue(
                                                'username',
                                                e.target.value
                                              );
                                            }}
                                          />
                                          <ErrorMessage name='username'>
                                            {(msg) => (
                                              <span
                                                className='fm_error'
                                                style={{ color: 'red' }}>
                                                {msg}
                                              </span>
                                            )}
                                          </ErrorMessage>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-6 col-lg-6'>
                                        <div className='form-group passwordHS'>
                                          <Field
                                            className='form-control'
                                            type={
                                              showHidePassword
                                                ? 'text'
                                                : 'password'
                                            }
                                            name='password'
                                            placeholder='New password'
                                          />
                                          <i
                                            onClick={() =>
                                              setShowHidePassword(
                                                !showHidePassword
                                              )
                                            }>
                                            {showHidePassword ? (
                                              <EyeIcon />
                                            ) : (
                                              <EyeOffIcon />
                                            )}
                                          </i>
                                          <ErrorMessage name='password'>
                                            {(msg) => (
                                              <span
                                                className='fm_error'
                                                style={{ color: 'red' }}>
                                                {msg}
                                              </span>
                                            )}
                                          </ErrorMessage>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-6 col-lg-6'>
                                        <div className='form-group passwordHS'>
                                          <Field
                                            className='form-control'
                                            type={
                                              showHideConfirmPassword
                                                ? 'text'
                                                : 'password'
                                            }
                                            name='confirmPassword'
                                            placeholder='Confirm password'
                                          />
                                          <i
                                            onClick={() =>
                                              setShowHideConfirmPassword(
                                                !showHideConfirmPassword
                                              )
                                            }>
                                            {showHideConfirmPassword ? (
                                              <EyeIcon />
                                            ) : (
                                              <EyeOffIcon />
                                            )}
                                          </i>
                                          <ErrorMessage name='confirmPassword'>
                                            {(msg) => (
                                              <span
                                                className='fm_error'
                                                style={{ color: 'red' }}>
                                                {msg}
                                              </span>
                                            )}
                                          </ErrorMessage>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-12 col-lg-12'>
                                        <div className='text-center'>
                                          <button
                                            type='submit'
                                            className='btn btn-primary d-inline-flex justify-content-center align-items-center'
                                            style={{
                                              width: '100px',
                                              height: '35px',
                                            }}
                                            disabled={isSubmitting}>
                                            {isSubmitting ? (
                                              <span
                                                class='spinner-border spinner-border-sm '
                                                role='status'
                                                aria-hidden='true'></span>
                                            ) : (
                                              'Save'
                                            )}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className='userinfo-form'>
            <div className='userinfo-formWrap'></div>
          </div>
        </div>
      </div>
      <FooterEnd />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setUserData: (data) => dispatch(setUserData(data)),
  setActiveTab: (data) => dispatch(setActiveTab(data)),
});

const mapStateToProps = ({ authReducer: { user } }) => ({
  user: user,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
